export function getPriceWithSeprator(price: number) {
    const priceParts = price.toFixed(2).split('.');
    let integerPart = '';
    for (let i = 0; i < priceParts[0].length; i++) {
        if ((priceParts[0].length - i) % 3 === 0) {
            integerPart += ' ';
        }
        integerPart += priceParts[0][i];
    }
    return integerPart + '.' + priceParts[1];
}
